import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { BBReferralLegType } from 'src/domains/sportsbook/betting/betSlipState/BetSlipTypes';
import {
    BetslipYouDecideWrapper,
    BetslipYouDecideLabel,
    BetslipYouDecideRabItemsWrapper,
    RabItems,
    RabItemsWrapper,
    RabItemsWrapperSelection,
    RabItemsWrapperMarket,
    BetslipYouDecideEventReturn,
    BetslipYouDecideReturn,
    ReturnWrapper,
} from 'src/domains/sportsbook/betting/ui/betSlip/BetslipShared.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { BasicDataModel } from 'src/domains/players/state/BasicDataModel';
import { Amount } from 'src_common/common/amount/Amount';

interface PropsType {
    bbBet: BBReferralLegType;
}

const getPotentialReturns = (
    price: number,
    stakePerLine: string,
    potentialReturns: BBReferralLegType['potentialReturns']
): string => {
    return potentialReturns === null || potentialReturns === undefined
        ? `${price * Number(stakePerLine)}`
        : potentialReturns;
};

export const BetslipBBReferral = observer('BetslipBBReferral', (props: PropsType) => {
    const common = useCommon();
    const { money } = BasicDataModel.get(common);
    const configComponents = ConfigComponents.get(common);
    const { config } = configComponents;
    const { bbBet } = props;
    const { price, stakePerLine } = bbBet;

    const priceLabel = price !== null && price !== undefined ? price.f : '';
    const priceDecimal = price !== null && price !== undefined ? price.d : 0;
    const rawPotentialReturns = getPotentialReturns(priceDecimal, stakePerLine, bbBet.potentialReturns);
    const potentialReturns = money(new Amount(rawPotentialReturns));
    const stakeDisplay = money(configComponents.precision.newFromAnything(stakePerLine));

    return (
        <BetslipYouDecideWrapper
            className='BetslipBBReferral'
            data-test='betslip-bb-referral-section'
        >
            <BetslipYouDecideLabel data-test='betslip-bb-referral-header'>
                {config.rabHeaderTitle}
            </BetslipYouDecideLabel>

            <BetslipYouDecideRabItemsWrapper>
                <RabItems>
                    <RabItemsWrapper>
                        <RabItemsWrapperSelection data-test='bb-referral-name'>{bbBet.name}</RabItemsWrapperSelection>
                        <RabItemsWrapperMarket data-test='bb-referral-price'>{priceLabel}</RabItemsWrapperMarket>
                    </RabItemsWrapper>
                </RabItems>
            </BetslipYouDecideRabItemsWrapper>

            <ReturnWrapper data-test='bb-referral-returns'>
                <BetslipYouDecideEventReturn>
                    <I18n
                        langKey='betslip.stake'
                        defaultText='Stake:'
                    />{' '}
                    <BetslipYouDecideReturn>{stakeDisplay}</BetslipYouDecideReturn>
                </BetslipYouDecideEventReturn>
                <BetslipYouDecideEventReturn>
                    <I18n
                        langKey='betslip.you-decide.returns'
                        defaultText='Returns:'
                    />{' '}
                    <BetslipYouDecideReturn>{potentialReturns}</BetslipYouDecideReturn>
                </BetslipYouDecideEventReturn>
            </ReturnWrapper>
        </BetslipYouDecideWrapper>
    );
});
